import React from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import i18next from 'i18next';

import { SelectInput } from '../SelectInput';
import { TextInput } from '../TextInput';
import { TextInputPhone } from '../TextInputPhone';
import { ActionResultTypesService, RolesService, ActionsService, LocalesService } from '../../services';
import ValidationHelper  from '../../helpers/validation_helper';

const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-action-name');
  }

  if (!values.description) {
    errors.description = i18next.t('messages.please-enter-action-description');
  }

  if(values.actionResults) {
    const actionResultsArrayErrors = [];

    values.actionResults.forEach((action, actionIndex) => {
      const actionResultsErrors = {};
      if (!action || !action.value) {
        actionResultsErrors.value = i18next.t('messages.please-enter-value');
        actionResultsArrayErrors[actionIndex] = actionResultsErrors;
      }

      if (!action || !action.type) {
        actionResultsErrors.type = i18next.t('messages.please-enter-type');
        actionResultsArrayErrors[actionIndex] = actionResultsErrors;
      }

      if (action && action.type && action.type.actionResultType && !action.type.actionResultType.isRoleBased && !action.locale) {
        actionResultsErrors.locale = i18next.t('messages.please-enter-language');
        actionResultsArrayErrors[actionIndex] = actionResultsErrors;
      }
    });

    if(actionResultsArrayErrors.length) {
      errors.actionResults = actionResultsArrayErrors;
    }
  }
  return errors
}

@connect(state => {
  return {
    form: state.form
  }
})
class ActionForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      actionResultTypes: null,
      hasError: false,
      roleOptions: [],
      showDeleteModal: false
    };

    let initData = {
      name: null,
      description: null,
      actionResults: []
    };

    if (this.props.action) {
      initData.name = this.props.action.name;
      initData.description = this.props.action.description;
      initData.actionResults = this.props.action.actionResults
                                        .filter(actionResult => !actionResult.archived)
                                        .filter(actionResult => actionResult.actionResultType.token != 'log')
                                        .sort((actionResultA, actionResultB) => actionResultA.id - actionResultB.id)
                                        .map(actionResult => {
                                          if (actionResult.actionResultType.isRoleBased) {
                                            return ({
                                              id: actionResult.id,
                                              value: { value: actionResult.role.id, label: actionResult.role.name },
                                              type: { value: actionResult.actionResultType.id, label: i18next.t(`action-result-types.${actionResult.actionResultType.token}`), actionResultType: actionResult.actionResultType }
                                            });
                                          } else if (actionResult.locale) {
                                            return ({
                                              id: actionResult.id,
                                              value: actionResult.value,
                                              type: { value: actionResult.actionResultType.id, label: i18next.t(`action-result-types.${actionResult.actionResultType.token}`), actionResultType: actionResult.actionResultType },
                                              locale: {value: actionResult.locale.languageTag, label: actionResult.locale.description}
                                            });
                                          } else {
                                            return ({
                                              id: actionResult.id,
                                              value: actionResult.value,
                                              type: { value: actionResult.actionResultType.id, label: i18next.t(`action-result-types.${actionResult.actionResultType.token}`), actionResultType: actionResult.actionResultType }
                                            });
                                          }
                                        });
    }
    this.props.initialize(initData);
  }

  componentDidMount() {
    ActionResultTypesService.getAll().then(response => {
      this.setState({
        actionResultTypes: response.actionResultTypes.filter(arType => arType.token != 'log')
      });
    }).catch(error => {
      console.error(error); // TODO handle error
    });

    RolesService.listAllForRoleType('group_role').then(response => {
      this.setState({ roleOptions: response.roles.map(role => ({ value: role.id, label: role.name })) });
    }).catch(error => {
      console.error(error);
      this.state.setState({ hasError: true });
      this.state.localErrorHandler(error.message);
    });

    LocalesService.getAll().then(response => {
      this.setState({ locales: response.locales.map(locale => {return {value: locale.languageTag, label: locale.description}})});
    }).catch(error => {
      console.error(error);
    });
  }

  toggleDeleteModal() {
    this.setState({showDeleteModal: !this.state.showDeleteModal});
  }

  archiveAction() {
    ActionsService.archiveAction(this.props.action.id).then(response => {
      this.setState({linkToList: true, successMessage: i18next.t('messages.action-deleted'), errorMessage: null});
    }).catch(error => {
      console.error(error);
      this.setState({linkToList: true, successMessage: null, errorMessage: i18next.t('messages.could-not-delete-action')});
    });
  }

  render() {
    if (this.state.linkToList) {
      return (
          <Redirect to={{
            pathname: '/config/actions',
            state: {
              successMessage: this.state.successMessage,
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }
    if (this.state.actionResultTypes && this.state.locales) {
      return (
        <div className="login-form">
          <form onSubmit={this.props.handleSubmit}>
            <div>
              <Field
                name="name"
                type="text"
                component={TextInput}
                label={i18next.t('form-labels.action-name')}
              />
            </div>

            <div>
              <Field
                name="description"
                type="text"
                component={TextInput}
                label={i18next.t('form-labels.action-description')}
              />
            </div>

            <hr />

            <div className="op-content-box-level-2 action-wrap">
              <FieldArray
                name="actionResults"
                actionResultTypes={this.state.actionResultTypes}
                roleOptions={this.state.roleOptions}
                locales={this.state.locales}
                action={this.props.action}
                component={ActionTypeEntry}
              />
            </div>

            <hr />

            <ul className="list-inline clearfix">
              <li><button type="submit" className="btn btn-primary btn-block">{i18next.t('form-labels.save')}</button></li>
              <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/config/actions`}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
               {this.props.alertConfigurations && this.props.alertConfigurations.length == 0 ? <li className="pull-right"><a className="btn btn-danger" onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('delete')}</a></li> : null }
               {this.props.alertConfigurations && this.props.alertConfigurations.length > 0 ? <li className="pull-right"> <p>{i18next.t('pages.actions.associated-with-alerts', {count: this.props.alertConfigurations.length})}</p> </li> : null}
            </ul>
          </form>
          <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{i18next.t('pages.actions.delete-action')}: {this.props.form.ActionForm.values ? this.props.form.ActionForm.values.name : ''}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{i18next.t('messages.are-you-sure-delete')}</p> <br />
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-danger" onClick={this.archiveAction.bind(this)}>{i18next.t('delete')}</a>
                <Button onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('form-labels.cancel')}</Button>
              </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}


class ActionTypeEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedActions: []
    };
  }

  getActionTypeOptions() {
    let actionTypeOptions = this.props.actionResultTypes;
    return actionTypeOptions.map(actionResultType => {
      return { value: actionResultType.id, label: i18next.t(`action-result-types.${actionResultType.token}`), actionResultType: actionResultType }
    })
  }

  updateActionTypeValue(index, newValue) {
    let newSelectedActions = this.state.selectedActions;
    newSelectedActions[index] = newValue.label; // todo: label?
    this.setState({ selectedActions: newSelectedActions });
    let field = this.props.fields.get(index);
    if (field && field.type && field.type.actionResultType.isRoleBased && !newValue.actionResultType.isRoleBased) {
      field.value = null
    }
    field.type = { actionResultType: this.props.actionResultTypes.find(actionResultType => actionResultType.id == newValue.value) };
    this.forceUpdate();
  }

  updateLocale(index, selectedLocale) {
    let field = this.props.fields.get(index);
    field.locale = this.props.locales.find(locale => locale.languageTag === selectedLocale.value);
  }

  removeSelectedAction(index, fields) {
    let newSelectedActions = this.state.selectedActions
    newSelectedActions.splice(index, 1);
    this.setState({ selectedActions: newSelectedActions });
    fields.remove(index);
  }

  unshiftSelectedActions(fields) {
    fields.unshift({});
    this.state.selectedActions.unshift("");
  }

  hasValue(index) {
    const field = this.props.fields.get(index);
    return field.type && field.type.actionResultType ? field.type.actionResultType.hasValue : false;
  }

  hasRoleValue(index) {
    const field = this.props.fields.get(index);
    return field.type && field.type.actionResultType ? field.type.actionResultType.isRoleBased : false;
  }

  isPhoneInput(index) {
    const ftype = this.props.fields.get(index).type;
    const token = ftype && ftype.actionResultType && ftype.actionResultType.token ? ftype.actionResultType.token : null;
    return token === 'ad_hoc_sms' || token === 'ad_hoc_voice';
  }

  componentWillReceiveProps(nextProps) {
    var hasUpdated = false;
    const roleIds = nextProps.roleOptions.map(roleOption => roleOption.value);
    this.props.fields.forEach((action, index) => {
      const field = this.props.fields.get(index);
      if (field && field.type && field.type.actionResultType && field.type.actionResultType.isRoleBased && field.value) {
        if (!roleIds.includes(field.value.value)) {
          field.value = null;
          hasUpdated = true;
        }
      }
    });
    if (hasUpdated) {
      this.forceUpdate();
    }
  }

  render() {
    let { fields, meta: { error } } = this.props;
    return (
    <div className="row">
    <div className="col-sm-12">
      <ul className="list-inline clearfix remove-margin-bottom actions-header">
        <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.actions.header')}</h4></li>
        <li className="pull-right">
          <button className="btn btn-default btn-sm" type="button" onClick={() => this.unshiftSelectedActions(fields)}>
            {i18next.t('pages.actions.add-action')}
          </button>
        </li>
      </ul>
    </div>
    <div className="col-sm-12 oc-mini-card oc-mini-card-gray">
      <div className="inner">
        <div className="row">
          <div className="col-sm-6"><label>{i18next.t('form-labels.type')}</label> <p>{i18next.t('log')}</p></div>
        </div>
      </div>
    </div>
        {fields.map((action, index) =>
          <div className="col-sm-12 oc-mini-card" key={index}>
            <div className="inner">
              <div className="row">
                <div className="col-sm-6 col-md-4 col-lg-5">
                  <label>{i18next.t('form-labels.type')}</label>
                  <Field
                    name={`${action}.type`}
                    options={this.getActionTypeOptions()}
                    clearable={false}
                    component={SelectInput}
                    onChange={(newValue) => this.updateActionTypeValue(index, newValue)}
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-lg-5">
                  {this.hasValue(index) && !this.hasRoleValue(index) ?
                    <div>
                      {this.isPhoneInput(index) ?
                        <Field
                        name={`${action}.value`}
                        type="text"
                        component={TextInputPhone}
                        label={i18next.t('form-labels.adhoc-entry')}
                        validate={ValidationHelper.validatePhoneNumber}
                        autoComplete="off"
                      />
                        :
                        <Field
                        name={`${action}.value`}
                        type="text"
                        component={TextInput}
                        label={i18next.t('form-labels.adhoc-entry')}
                        validate={ValidationHelper.validateEmail}
                        autoComplete="off"
                      />}
                      <label>{i18next.t('form-labels.language')}</label>
                      <Field
                        name={`${action}.locale`}
                        options={this.props.locales}
                        clearable={false}
                        component={SelectInput}
                        onChange={(selectedLocale) => this.updateLocale(index, selectedLocale)}
                      />
                    </div>: null}
                  {this.hasValue(index) && this.hasRoleValue(index) ?
                    <div>
                      <label>{i18next.t('form-labels.distribution-group')}</label>
                      <Field
                        name={`${action}.value`}
                        options={this.props.roleOptions}
                        clearable={false}
                        component={SelectInput}
                      />
                    </div>: null}
                </div>
                <div className="col-sm-6 col-md-4 col-lg-2 action-button">
                  <label>&nbsp;</label>
                  <button
                    className="btn btn-danger"
                    type="button"
                    title={i18next.t('pages.actions.remove-action')}
                    onClick={() => this.removeSelectedAction(index, fields)}>{i18next.t('pages.actions.remove-action')}</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {error &&
          <div className="error">
            {error}
          </div>}

    </div>
    );
  }
}

export default reduxForm({ form: 'ActionForm', validate })(ActionForm);
